import { toggleLiveChatDisplay } from '~/portal/components/LiveChat/helpers.ts'

const DOMAIN = 'https://smartbear.my.site.com'
const scrt2URL = 'https://smartbear.my.salesforce-scrt.com'

const toggleStorageItem = (key: string, value: boolean) => {
  globalThis.window.localStorage.setItem(key, value.toString())
  globalThis.window.dispatchEvent(new StorageEvent('storage', {
    key,
    newValue: value.toString(),
    oldValue: (!value).toString()
  }))
}

export class AgentForce {
  static instance: AgentForce
  private instanceCreated = false
  email: string | null = null

  constructor(data: { email: string | null }) {
    this.email = data.email
  }

  static getInstance(data: { email: string | null }): AgentForce {
    if (!AgentForce.instance) {
      AgentForce.instance = new AgentForce(data)
    } else if (data.email !== AgentForce.instance.email) {
      AgentForce.instance.email = data.email
    }
    return AgentForce.instance
  }

  private initEmbeddedMessaging() {
    try {
      globalThis.window.embeddedservice_bootstrap.settings.language = 'en_US'
      globalThis.window.embeddedservice_bootstrap.settings.chatButtonPosition = '-1000px,-1000px' // Hide the default chat button initially
      globalThis.window.embeddedservice_bootstrap.settings.shouldMinimizeWindowOnNewTab = true

      globalThis.window.embeddedservice_bootstrap.init(
        '00D700000008FQP',
        'Embedded_Deployment_for_Service_Agent',
        `${DOMAIN}/ESWEmbeddedDeploymentfo1739388094135`,
        {
          scrt2URL,
        }
      )

      globalThis.window.addEventListener('onEmbeddedMessagingReady', () => {
        if (this.email) {
          globalThis.window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({ Email: this.email })
        }
        toggleStorageItem('liveChatScriptLoaded', true)
      })

      globalThis.window.addEventListener('onEmbeddedMessagingConversationOpened', () => {
        toggleStorageItem('liveChatLaunched', true)
      })

      globalThis.window.addEventListener('onEmbeddedMessagingWindowMinimized', () => {
        toggleStorageItem('liveChatLaunched', true)
        toggleLiveChatDisplay(false)
      })

      globalThis.window.addEventListener('onEmbeddedMessagingWindowMaximized', () => {
        toggleStorageItem('liveChatMinimized', false)
      })

      globalThis.window.addEventListener('onEmbeddedMessagingChannelMenuVisibilityChanged', () => {
        toggleStorageItem('liveChatLaunched', false)
      })

      this.instanceCreated = true
    } catch (err) {
      console.error('Error loading Embedded Messaging: ', err)
    }
  }

  initAgentForceScript() {
    if (this.instanceCreated) {
      console.warn('AgentForce script already initialized.')
      return
    }

    const script = document.createElement('script')
    script.src = `${DOMAIN}/ESWEmbeddedDeploymentfo1739388094135/assets/js/bootstrap.min.js`
    script.onload = () => this.initEmbeddedMessaging()
    script.onerror = err => console.error('Error loading script:', err)
    document.body.appendChild(script)
  }
}